import React from "react";
import { CheckCircleOutlined, EditOutlined } from "@ant-design/icons";
import { ToastContainer } from "react-toastify";
import FieldRow from "./components/FieldRow";
import ProfileHeader from "./components/ProfileHeader";
import ProfileActions from "./components/ProfileActions";
import { useProfile } from "./hooks/useProfile";

const Profile: React.FC = () => {

  const {
    profileData,
    editData,
    loading,
    isEditing,
    confirmPassword,
    profileSlug,

    setIsEditing,
    setConfirmPassword,

    handleInputChange,
    handleSave,
    handleCancel,
   } = useProfile();

  const inputClass = `w-full px-3 py-2.5 rounded-xl text-sm text-blue-900
    border border-blue-200 bg-white/85 placeholder-blue-300
    hover:border-blue-400 focus:outline-none focus:border-blue-500
    focus:ring-4 focus:ring-blue-100 transition-all duration-200`;

  const inlineEditBtn = (
    <button
      onClick={() => setIsEditing(true)}
      className="text-xs font-semibold text-blue-500 px-3 py-1.5 rounded-lg
                 bg-blue-50 border border-blue-100
                 hover:bg-blue-100 hover:border-blue-200
                 transition-all duration-200 whitespace-nowrap"
    >
      <EditOutlined style={{ fontSize: 11, marginRight: 4 }} />
      Modifier
    </button>
  );

  if (loading)
    return (
      <div className="px-6 py-8 max-w-2xl mx-auto">
        <div className="bg-white rounded-2xl border border-blue-100 shadow-sm p-12 flex flex-col items-center gap-3 text-slate-400">
          <div className="h-9 w-9 rounded-full border-[3px] border-blue-100 border-t-blue-500 animate-spin"/>
          <span className="text-sm font-medium">Chargement du profil...</span>
        </div>
      </div>
    );

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-8 max-w-2xl mx-auto ">

      <ToastContainer />

      <div className="bg-white  backdrop-blur-xl rounded-2xl border border-blue-100 shadow-sm overflow-hidden">

        <div className="h-[3px] w-full bg-gradient-to-r from-blue-700  to-blue-00"/>

        <ProfileHeader
          slug={profileSlug}
          isEditing={isEditing}
          onToggleEdit={() => setIsEditing(!isEditing)}
        />
        <FieldRow label="Nom complet *" description=" ">
          {isEditing ? (
            <input
              value={editData.nom}
              onChange={(e)=>handleInputChange("nom", e.target.value)}
              className={inputClass}
            />
          ) : (
            <div className="flex items-center justify-between">
              <span className="text-sm font-medium text-slate-700">
                {profileData.nom}
              </span>
              {inlineEditBtn}
            </div>
          )}
        </FieldRow>

        <FieldRow label="Email de contact *" description=" ">
          <span className="text-sm font-medium text-slate-700">
            {profileData.email}
          </span>
        </FieldRow>

      

        <FieldRow label="Mot de passe *" description="Mot de passe sécurisé.">
          {isEditing ? (
            <div className="flex flex-col gap-2">

              <input
                type="password"
                value={editData.password}
                onChange={(e)=>handleInputChange("password", e.target.value)}
                className={inputClass}
                placeholder="Nouveau mot de passe"
              />

              <input
                type="password"
                value={confirmPassword}
                onChange={(e)=>setConfirmPassword(e.target.value)}
                className={inputClass}
                placeholder="Confirmer le mot de passe"
              />

            </div>
          ) : (
            <span className="text-sm tracking-widest">••••••••</span>
          )}
        </FieldRow>

        <FieldRow label="Statut du compte" description="Statut de vérification.">
          <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold border ${
              profileData.isVerified
                ? "bg-green-50 text-green-700 border-green-200"
                : "bg-slate-100 text-slate-500 border-slate-200"
            }`}>
            <CheckCircleOutlined style={{fontSize:11}}/>
            {profileData.isVerified ? "Compte vérifié" : "Compte non vérifié"}
          </span>
        </FieldRow>

        {isEditing && (
          <ProfileActions
            onSave={handleSave}
            onCancel={handleCancel}
          />
        )}

      </div>
    </div>
  );
};

export default Profile;